import clsx from 'clsx';

type StatusVariant = 'rejected' | 'revised';

interface StatusBadgeProps {
  variant: StatusVariant;
  className?: string;
}

const getStatusConfig = (variant: StatusVariant) => {
  const configs = {
    rejected: {
      label: 'Rejected',
      styles: 'bg-primary-900 text-primary-500',
    },
    revised: {
      label: 'Revised',
      styles: 'bg-secondary-900 text-secondary-400',
    },
  };

  return configs[variant];
};

export const StatusBadge = ({ variant, className }: StatusBadgeProps) => {
  const config = getStatusConfig(variant);

  return (
    <div
      className={clsx(
        'z-10 absolute -top-3.5 right-0 rounded-md bg-neutral-white p-1 shadow-sm',
        className,
      )}
    >
      <p className={clsx('rounded px-2 py-0.5 typography-loud-xs', config.styles)}>
        {config.label}
      </p>
    </div>
  );
};
